import React, { useEffect, useState } from 'react';
import { useRoomStore } from '../../../stores/room';
import { useUserStore } from '../../../stores/user';
import { UserStream } from '../../../widgets/user';

import styles from './group.module.css';

export function GroupRoom(props){
    const { participants } = useRoomStore();
    const { id: userId } = useUserStore();
    const [activeParticipants, setActiveParticipants] = useState(participants.filter(p => p.status === 'Connected' || p.status === 'Inactive'));
    useEffect(() => {
        setTimeout(() => {
            if(activeParticipants.length <= 11){
                setActiveParticipants([...activeParticipants, ...participants.filter(p => p.status === 'Connected' || p.status === 'Inactive')]);
            }
        }, 2000)
    }, [activeParticipants]);
    return <div className={`${styles.room} ${styles['count' + activeParticipants.length]}`}>
        {activeParticipants.map((p, i) => <UserStream name={p.name} streams={p.streams} showName={p.pesuId !== userId} key={i} participant={p} />)}
    </div>
}